import React, { useState, useEffect } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { GroupingWithId } from './MetadataInterfaces';

interface GroupingFormProps {
  grouping?: GroupingWithId;
  onSave: (grouping: Omit<GroupingWithId, 'id'>) => void;
  onCancel: () => void;
}

const GroupingForm: React.FC<GroupingFormProps> = ({
  grouping,
  onSave,
  onCancel,
}) => {
  const [key, setKey] = useState(grouping?.Key || '');
  const [title, setTitle] = useState(grouping?.Title || '');

  useEffect(() => {
    if (grouping) {
      setKey(grouping.Key);
      setTitle(grouping.Title);
    }
  }, [grouping]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ Key: key, Title: title });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <TextField
        fullWidth
        label="Key"
        value={key}
        onChange={(e) => setKey(e.target.value)}
        margin="normal"
        required
      />
      <TextField
        fullWidth
        label="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        margin="normal"
      />
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default GroupingForm;
